module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-flash_item J_flash_item",
    class: [{
      'is-relevance': _vm.data.isRelevanceActive,
      'is-relevance-important': _vm.data.isRelevanceImportant,
    } ],
    attrs: {
      "data-relevance": _vm.data.type === 0 && _vm.data.relevance ? _vm.data.relevance : null
    }
  }, [_c('div', {
    staticClass: "ushk-flash_h"
  }, [_c('div', {
    staticClass: "ushk-flash_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_time"
  }, [_vm._v(_vm._s(_vm.data.time_view))])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_b"
  }, [(_vm.data.type === 0) ? _c('div', {
    class: [
      _vm.data.type === 0 ? {
        important: _vm.data.important
      } : '',
      _vm.data.data.star ?
      _vm.data.data.type === 1 ?
      ("star" + (_vm.data.data.star)) :
      _vm.data.data.star > 2 ?
      'important' :
      '' :
      '' ]
  }, [_c('div', {
    staticClass: "ushk-flash_text",
    class: {
      'is-only-text': !_vm.data.data.pic
    }
  }, [_c('div', {
    staticClass: "ushk-flash_text-box",
    on: {
      "click": _vm.onRecord
    }
  }, [(_vm.data.data.title) ? _c('div', {
    staticClass: "ushk-flash_text-box_title"
  }, [_c('b', [_vm._v(_vm._s(_vm.data.data.title))])]) : _vm._e(), _vm._v(" "), (_vm.data.data.tag) ? _c('span', {
    staticClass: "ushk-flash_text-tag"
  }, [_vm._v(_vm._s(_vm.data.data.tag))]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.flashFormat(_vm.data))
    }
  }), _vm._v(" "), (_vm.data.data.link) ? _c('a', {
    staticClass: "ushk-flash_text-more1",
    attrs: {
      "href": _vm.data.data.link,
      "target": "_blank"
    }
  }, [_vm._v("阅读更多"), _c('i', {
    staticClass: "ushk-icon ushk-icon_rightArrow"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.data.data.pic) ? _c('div', {
    staticClass: "ushk-flash_attach"
  }, [(_vm.data.data.pic) ? _c('viewer', {
    staticClass: "ushk-flash_image",
    attrs: {
      "options": {
        url: 'data-source'
      }
    }
  }, [(_vm.data.isSocket) ? _c('img', {
    attrs: {
      "src": _vm.data.data.picLite,
      "data-source": _vm.data.data.pic
    }
  }) : _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.data.data.picLite),
      expression: "data.data.picLite"
    }],
    attrs: {
      "data-source": _vm.data.data.pic
    }
  })]) : _vm._e()], 1) : _vm._e()]) : (_vm.data.type === 1 || _vm.data.type === 3) ? [_c('div', {
    staticClass: "ushk-flash_data"
  }, [_c('h4', {
    staticClass: "ushk-flash_data-title"
  }, [_c('div', {
    staticClass: "ushk-flash_data-country"
  }, [(_vm.data.isSocket) ? _c('img', {
    attrs: {
      "src": ("//cdn.jin10.com/assets/img/commons/flag/" + (_vm.data.data.country) + ".png")
    }
  }) : _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (
        ("//cdn.jin10.com/assets/img/commons/flag/" + (_vm.data.data.country) + ".png")
      ),
      expression: "\n                `//cdn.jin10.com/assets/img/commons/flag/${data.data.country}.png`\n              "
    }]
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.data.content))])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_data-text"
  }, [_c('p', [_c('span', [_vm._v("前值：")]), _vm._v(_vm._s(_vm.data.data.previous || "--"))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("预期：")]), _vm._v(_vm._s(_vm.data.data.consensus || "--"))]), _vm._v(" "), _c('p', {
    staticClass: "ushk-flash_data-published"
  }, [_c('span', [_vm._v("公布：")]), _vm._v(" "), _c('b', {
    class: _vm.data.data.evaluateClass
  }, [_vm._v(_vm._s(_vm.data.data.actual))])])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_data-correction",
    attrs: {
      "id": _vm.data.data.data_id
    }
  }, [_vm._v("\n          " + _vm._s(_vm.data.data.revised) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_data-wrap"
  }, [_c('div', {
    staticClass: "ushk-flash_data-vote"
  }, [_c('star', {
    attrs: {
      "tag-name": "p",
      "width": _vm.data.data.star
    }
  })], 1), _vm._v(" "), (_vm.data.data.show_affect && _vm.data.data.country !== '中国') ? _c('div', {
    staticClass: "ushk-flash_data-tag ushk-tag_trend"
  }, [_c('p', {
    class: _vm.data.data.evaluateClass
  }, [_c('span', {
    staticClass: "ushk-btn J_kind_tag",
    attrs: {
      "data-trend": _vm.data.data.trend
    }
  }, [_c('em', {
    staticClass: "J_kind_trend"
  }, [_vm._v(_vm._s(_vm.data.data.evaluate))]), _vm._v(" "), _c('i', {
    staticClass: "J_kind_trendType"
  }, [_vm._v(_vm._s(_vm.data.data.kind))])])])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "ushk-flash_data-pubdate"
  }, [_vm._v(_vm._s(_vm.data.data.pubDate))])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash-remark-con"
  }, [(_vm.data.data.sentiment) ? _c('img', {
    attrs: {
      "src": require(("@/assets/img/" + (_vm.data.data.sentiment) + ".png")),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.remark) ? _c('ul', {
    staticClass: "ushk-flash-remark"
  }, _vm._l((_vm.data.remark), function(remarkItem, index) {
    return (!remarkItem.lock) ? _c('li', {
      staticClass: "ushk-flash-remark__item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onRemarkClick(remarkItem)
        }
      }
    }, [_c('i', {
      staticClass: "ushk-icon",
      class: ("ushk-icon_remark-" + (remarkItem.type))
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(remarkItem.title))])]) : _vm._e()
  }), 0) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93001fee","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/Message.vue
// module id = Wpw8
// module chunks = 1